/* TODO: t() */
import React, { ComponentProps } from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';

import Text from './Text';
import { hitSlop, themeColors } from './Constants';

type Props = ComponentProps<typeof View> & {
  title?: string;
  text: string;
  id?: string;
  type: 'error' | 'success' | 'warning';
  onDismiss: () => void;
  allowResize?: boolean;
  allowMultiline?: boolean;
};
type DismissButtonProps = Pick<Props, 'type' | 'onDismiss'>;

export { Props as AlertProps };

function alertTextColor(type: Props['type']) {
  return {
    color:
      type === 'success'
        ? themeColors.greenToastText
        : type === 'warning'
        ? themeColors.orangeToastText
        : themeColors.redToastText,
  };
}

function Alert(props: Props) {
  let {
    title,
    text,
    onDismiss,
    style,
    type,
    allowResize,
    allowMultiline,
    id,
    ...otherProps
  } = props;
  let textColor = alertTextColor(type);

  const content =
    title != null ? (
      <View style={styles.alertContentContainer}>
        <Text
          style={[
            styles.alertTitle,
            textColor,
            !allowResize && !allowMultiline && styles.noWrap,
          ]}
        >
          {title}
        </Text>
        <Text
          nativeID={id}
          style={[
            styles.alertText,
            textColor,
            !allowResize && !allowMultiline && styles.noWrap,
          ]}
        >
          {text}
        </Text>
      </View>
    ) : (
      <Text
        nativeID={id}
        style={[
          styles.alertText,
          textColor,
          !allowResize && !allowMultiline && styles.noWrap,
        ]}
      >
        {text}
      </Text>
    );

  return (
    <View
      style={[
        styles.alert,
        type === 'warning' && styles.warning,
        type === 'success' && styles.success,
        style,
      ]}
      {...otherProps}
    >
      {content}
      <DismissButton type={type} onDismiss={onDismiss} />
    </View>
  );
}

function DismissButton(props: DismissButtonProps) {
  let { onDismiss, type } = props;
  let textColor = alertTextColor(type);

  return (
    <TouchableOpacity
      onPress={onDismiss}
      hitSlop={hitSlop}
      accessibilityRole="button"
    >
      <Text style={[styles.dismissText, textColor]}>×</Text>
    </TouchableOpacity>
  );
}

let styles = StyleSheet.create({
  alert: {
    flexDirection: 'row',
    paddingVertical: 16,
    paddingLeft: 12,
    paddingRight: 12,
    backgroundColor: themeColors.redToast,
    borderRadius: 4,
  },
  alertContentContainer: {
    flex: 1,
  },
  alertTitle: {
    flex: 1,
    marginRight: 10,
    lineHeight: 20,
    fontSize: 18,
  },
  alertText: {
    flex: 1,
    marginRight: 10,
    lineHeight: 20,
  },
  noWrap: {
    maxHeight: 20,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  warning: {
    backgroundColor: themeColors.orangeToast,
  },
  success: {
    backgroundColor: themeColors.greenToast,
  },
  dismissText: {
    fontSize: 21,
    lineHeight: 20,
    color: themeColors.redToastText,
    position: 'relative',
    top: -2,
  },
});

export default Alert;
